module.exports = __webpack_public_path__ + "static/media/reservationTime30.1e9a1c9c.svg";